import { EntityFormGroup } from './EntityFormGroup';

export class ImportEntity {
	id: string;
	database_entity: string;
	readable_name: string;
	fields: Object = {};
	display_mode: string = 'list';
	form_groups: EntityFormGroup[];
	form_model: Object = {};
}